import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./utils/ScrollToTop";
import { Layout } from "./component/common/Layout/Layout";

/* ------------------------------- Компоненты ------------------------------- */
import { Header } from "./component/Header/Header";

const HomePage = lazy(() => import("./pages/HomePage/HomePage.jsx"));
const DescryptionPage = lazy(() =>
	import("./pages/DescryptionPage/DescryptionPage.jsx")
);
const BetonDescription = lazy(() =>
	import("./component/BetonDescription/BetonDescription.jsx")
);
const SprayDescription = lazy(() =>
	import("./component/SprayDescription/SprayDescription.jsx")
);
const VerticalDescription = lazy(() =>
	import("./component/VerticalDescription/VerticalDescription.jsx")
);
const GalleryPage = lazy(() => import("./pages/GalleryPage/GalleryPage.jsx"));
const AboutPage = lazy(() => import("./pages/AboutPage/AboutPage.jsx"));
const ContactPage = lazy(() => import("./pages/ContactPage/ContactPage.jsx"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound.jsx"));

/* ----------------- Утилита при переключении на конкретную страничку подымает скрол к верху ----------------- */

function App() {
	return (
		<>
			<ScrollToTop />
			<Header />
			<Routes>
				<Route path="/" element={<Layout />}>
					<Route index element={<HomePage />} />

					<Route
						path="description-page"
						element={<DescryptionPage />}>
						<Route
							index
							element={<Navigate to="beton-descriptin" replace />}
						/>
						<Route
							path="beton-descriptin"
							element={<BetonDescription />}
						/>
						<Route
							path="spray-descriptin"
							element={<SprayDescription />}
						/>
						<Route
							path="vertical-descriptin"
							element={<VerticalDescription />}
						/>
					</Route>

					<Route path="gallery" element={<GalleryPage />} />
					<Route path="about" element={<AboutPage />} />
					<Route path="contact" element={<ContactPage />} />
					<Route path="*" element={<NotFound />} />
				</Route>
			</Routes>
		</>
	);
}

export default App;
